import { render, staticRenderFns } from "./BasicEmployeeCard.vue?vue&type=template&id=5109685d&scoped=true"
import script from "./BasicEmployeeCard.vue?vue&type=script&lang=ts"
export * from "./BasicEmployeeCard.vue?vue&type=script&lang=ts"
import style0 from "./BasicEmployeeCard.vue?vue&type=style&index=0&id=5109685d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5109685d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5109685d')) {
      api.createRecord('5109685d', component.options)
    } else {
      api.reload('5109685d', component.options)
    }
    module.hot.accept("./BasicEmployeeCard.vue?vue&type=template&id=5109685d&scoped=true", function () {
      api.rerender('5109685d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/card/BasicEmployeeCard.vue"
export default component.exports